import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { formatViews, getTypeLabel } from "@/utils/media";

interface MediaCardProps {
  item: MediaItem;
  showPlay?: boolean;
}

export default function MediaCard({ item, showPlay = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 在线观看`}
          className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/10 to-transparent opacity-80" />

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[11px] font-semibold font-label">
          {getTypeLabel(item.type)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-950/70 backdrop-blur text-accent-400 text-[11px] font-semibold font-label flex items-center gap-1">
          <i className="ri-star-fill text-[10px]" />
          {item.rating.toFixed(1)}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-3 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
          <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1">{item.title}</h3>
          <p className="text-[11px] text-foreground-600 mt-0.5 line-clamp-1">
            {item.year} · {item.genres.slice(0, 2).join("/")}
          </p>
        </div>

        <div className="absolute inset-0 bg-background-950/85 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4 flex flex-col justify-center">
          <p className="text-xs text-foreground-700 leading-relaxed line-clamp-4">{item.description}</p>
          <span className="mt-3 inline-flex items-center gap-1.5 text-xs text-primary-400 font-medium">
            <i className="ri-play-circle-fill text-lg" />
            查看详情
          </span>
        </div>

        {showPlay && (
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-12 h-12 rounded-full bg-primary-500/90 text-background-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <i className="ri-play-fill text-2xl" />
            </span>
          </span>
        )}
      </div>

      <div className="p-3">
        <div className="flex items-center justify-between gap-2">
          <span className="text-[11px] text-foreground-600">{item.region}</span>
          <span className="text-[11px] text-foreground-600 flex items-center gap-1">
            <i className="ri-fire-line text-primary-500" />
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}